import React, { useContext } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { AppContext } from 'context/app';
import { WebRTCProvider } from 'context/webRTC';
import { LeavesContext } from 'context/leaves';
import { Loading } from 'components/common/Loading';
import { GridView } from 'layout/camera/GridView';
import { filterLeavesByDeviceType, getDeviceLeafById } from 'modules/leaves';
const CameraGridComponent = () => {
  const {
    deviceOrder
  } = useContext(AppContext);
  const {
    leafStore,
    loading
  } = useContext(LeavesContext);
  const leaves = leafStore.read();
  if (loading) {
    return <Loading />;
  }
  if (leaves) {
    const cameraLeaves = filterLeavesByDeviceType(leaves, ['camera', 'doorbell']);
    const orderedCameraLeaves = deviceOrder.map(id => getDeviceLeafById(cameraLeaves, id)).filter(leaf => leaf !== null);
    return <WebRTCProvider>
        <GridView deviceLeaves={orderedCameraLeaves} />
      </WebRTCProvider>;
  }
};
export const Route = createFileRoute('/')({
  component: CameraGridComponent
});
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
      newModule.Route.clone(Route);
    }
  });
}